export default __webpack_public_path__ + "static/media/step2_3.d7c99d2c.png";